import * as Icons from "lucide-react";

// Dynamically render a lucide icon by name coming from JSON.
export default function Icon({ name, className, ...props }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} {...props} />;
}
